// extracted by mini-css-extract-plugin
module.exports = {"s1kmocrk":"s1kmocrk"};